<template>
  <FullScreenLayout ref="layout">
    <template #page-content="">
      <v-card class="form-card" style="width: 99%" outlined :elevation="10">
        <FrmPlanner
          :refreshInterval="10000"
          ref="planner"
          :allow-drag-and-drop-events="Boolean(false)"
          :allow-edit-events="Boolean(false)"
          :allow-select-cells="Boolean(false)"
          :showCellHover="Boolean(false)"
          v-bind:height="plannerHeight"
          :resourceType="resourceType"
          :full-screen="Boolean(true)"
          :showToolbar="Boolean(false)"
          :showOptions="Boolean(false)"
          :showBackButton="Boolean(false)"
          :showTitlebar="Boolean(false)"
          :title="String('Eventi pianificati')"
          :mode="PlannerMode.PlannerViewer"
        ></FrmPlanner>
      </v-card>
    </template>
  </FullScreenLayout>
</template>


<script>
const ScrollSpeed = {
  Slow: 0,
  Normal: 1,
  Fast: 2,
};
// const ScrollDirection = {
//   TopToBottom: +1,
//   BottomToTop: -1,
// };

 import PlannerMode from '../settings/PlannerMode' 
import FrmPlanner from "../components/Planner/FrmPlanner";
import moment from "moment";
import VueSmoothScroll from "vue2-smooth-scroll";
import UISettingsHelper from "../utils/UISettingsHelper";
import FullScreenLayout from "../layout/FullScreenLayout";
import $ from "jquery";
import Vue from "vue";
import SessionHelper from "@/utils/SessionHelper";
Vue.use(VueSmoothScroll); 
export default {
  props: {},
  data: function () {
    return {
      resourceType: "All",
      windowHeight: 0,
      creationDate: new Date(),
      ScrollSpeed: ScrollSpeed.Normal,
      backScrollSpeed:-1,
      PlannerMode:PlannerMode
    };
  },
  created() {
    UISettingsHelper.Configure(this.$route.params.companyAlias);

    this.adjustScrollSpeed();
    
    setInterval(()=>{

      UISettingsHelper.Pull(this.$route.params.companyAlias, (uiSettings) => {
        this.adjustScrollSpeed();
      });
    },10000)
    if (this.$route.query["type"] != undefined)
      this.resourceType = this.$route.query["type"];
    else this.resourceType = "All";
  },
  methods: {
    sleep: function (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    scrollTo: async function (el, scrollDirection, value) {
      //  this.$smoothScroll({duration:1000,offset:value,updateHistory:false});
      console.info("scrolling to", value);
      $(".v-data-table__wrapper").animate({ scrollTop: value }); //(0,value);
      // let isScrolling = true;

      // console.debug("value", value);
      // console.debug("max", el.scrollHeight-el.clientHeight);
      // console.debug("max-scroll-top", el.scrollHeight);
      // console.debug("max-scroll-top", el);
      // while (isScrolling) {
      //   console.debug("scroll-y", el.scrollTop);
      //   let maxReached=(scrollDirection>0 && el.scrollTop == el.scrollHeight-el.clientHeight) || (scrollDirection<0 && el.scrollTop ==0);
      //   let pointReached=( el.scrollTop == value)
      //   if ( !maxReached && !pointReached) {
      //     el.scrollTop = el.scrollTop + pxIncrement *scrollDirection;
      //   } else {
      //     isScrolling = false;
      //     console.debug("MAX RAGGIUNTO");
      //     // callback(el.scrollTop, maxReached);
      //     return (maxReached);
      //   }

      //    await this.sleep(10);
      // }

      // return;
    },

    adjustScrollSpeed: function () {
      
      this.ScrollSpeed = ScrollSpeed.Normal;

      let uiSettings = UISettingsHelper.GetSettings();
      if (Number.parseInt(uiSettings?.plannerViewer?.scrollerSpeed) >=0) {
        //vedo se c'è nel localstorage un impostazione 
        this.ScrollSpeed = uiSettings?.plannerViewer?.scrollerSpeed;
      }
      if (this.$route.query["speed"] != undefined)
        //priorità più alta se lo passano come parametro
        this.ScrollSpeed = this.$route.query["speed"];

      if (this.ScrollSpeed > ScrollSpeed.Fast)
        this.ScrollSpeed = ScrollSpeed.Fast;
      else if (this.ScrollSpeed < ScrollSpeed.Slow)
        this.ScrollSpeed = ScrollSpeed.Slow;
      this.$route.query["speed"] = this.ScrollSpeed;
    },

    startScroll: async function () {
      this.adjustScrollSpeed();
      let scrollDuration = 0; 
      var scrollDelay = 10000;

      let delay4Row = 15000 - (this.ScrollSpeed * 2500); //tempo impiegato dall'utente per leggere una singola riga

      scrollDuration = 10000 - this.ScrollSpeed * 2500;

      let el = document.getElementsByClassName("v-data-table__wrapper")[0];
      // let elRow = document.getElementsByTagName("td")[0];
      let rowsCount = $(".calendar-item").length; // document.getElementsByTagName("tr").length;
      let scrolledRows = 0;
      let lastScrollTop = 0;
      // console.debug("HEIGHT",el.scrollHeight-el.clientHeight);
      setInterval(() => {
        // console.debug("el", el);
        let rowHeight = $(".calendar-item").first().outerHeight(); //elRow.clientHeight +1;
        console.debug("rowHeight", rowHeight);
        console.debug("sc:rowsCount", rowsCount);
        let visibleRows = Math.floor(el.clientHeight / rowHeight) - 1;

        // scrollDelay = delay4Row * visibleRows;

        if (scrolledRows == rowsCount - 1) {
          scrolledRows = 0;
          lastScrollTop = 0;
        } else {
          if (scrolledRows + visibleRows < rowsCount - 1)
            scrolledRows += visibleRows;
          else scrolledRows += rowsCount - scrolledRows;
          scrolledRows--;
          let nextEl = $(".calendar-item-" + scrolledRows).first();
          if (nextEl !== undefined) lastScrollTop += nextEl.offset().top;
        }
        console.info("sc:scrolledRows", scrolledRows);
        console.info("sc:lastScrollTop", lastScrollTop);

        $(".v-data-table__wrapper").animate(
          {
            scrollTop: lastScrollTop,
          },
          scrollDuration,
          "linear",
          () => {
            console.info("scrolled");
          }
        );
      }, scrollDelay + scrollDuration);
    },
  },
  components: {
    FrmPlanner,
    FullScreenLayout,
  },
  mounted() {
    this.windowHeight = window.innerHeight; //this.$refs.layout.clientHeight;// window.innerHeight-100;
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight; //this.$refs.layout.clientHeight;//window.innerHeight-300;
    });
    this.creationDate = new Date(
      Date.parse(moment(new Date()).format("MM/DD/YYYY"))
    );

    setTimeout(this.startScroll, 3000); //il ritardo serve perchè può essere che il componente non è ancora renderizzato;
  },
  computed: {
    plannerHeight() {
      return this.windowHeight;
    },
  },
};
</script>